
































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class StaticField extends Vue {
  @Prop({ default: "" })
  public label!: string;

  @Prop({ default: null })
  public value!: boolean | null;

  @Prop({ default: null })
  public action!: string | boolean;

  @Prop({ default: false })
  public isOpen!: boolean;

  @Prop({ default: true })
  public trimLongValue!: boolean;

  @Prop({ default: true })
  public isAnimated!: boolean;

  @Prop({ default: false })
  public alwaysShowAction!: boolean;

  @Prop({ default: "" })
  public iconType!: string;

  public onClick() {
    if (this.action) {
      this.$emit("click");
    }
  }
}
